import React from 'react';
import { connect } from 'react-redux';
// GameGuide imports
import { GuideStepEnum } from '../../../shared';
import GameGuideNavLink from './link';

class GameGuideNavigation extends React.Component {
    render = () => {
        const { game, hide } = this.props;

        if (hide) {
            return <nav id="gameguide-nav" />;
        }
        return (
            <nav id="gameguide-nav">
                <ul>
                    <GameGuideNavLink title="1" step={GuideStepEnum.SPELER} />
                    <GameGuideNavLink title="2" step={GuideStepEnum.DOEL_SCORE} />
                    <GameGuideNavLink title="3" step={GuideStepEnum.LEVEL} />
                    <GameGuideNavLink title="4" step={GuideStepEnum.INFO} locked={game.levels.length > 0 ? undefined : true} />
                </ul>
            </nav>
        );
    }
};

GameGuideNavigation.defaultProps = {
    hide: false
};

const mapStateToProps = state => ({
    game: state.game
});

export default connect(
    mapStateToProps
)(GameGuideNavigation);
